import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { BaseSafeFormView, BaseView } from '@/components/base'
import { StickyHeaderNavigation } from '@/components/StickyHeaderNavigation'
import {
  SelectAccount,
  DetailInfos,
  KemCardDisclaimer,
} from '@/features/kem-card'

export const KemCardInfoScreen: React.FC = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <BaseSafeFormView flex={1} bgColor="background.screen" className="h-full">
      <StickyHeaderNavigation
        title={t('translation:kemCard.cardInfo')}
        onBackPress={() => navigate(-1)}
      />

      <BaseView
        style={{
          flex: 1,
          overflowY: 'auto',
          // paddingTop: 20,
          paddingBottom: 20,
        }}
      >
        {/* Account Selection - USDT Currency */}
        {/* <SelectAccount /> */}

        {/* Detailed Information about fees and card details */}
        <DetailInfos
          containerStyle={{
            paddingTop: 12,
            paddingBottom: 18,
          }}
        />

        {/* Disclaimer */}
        <KemCardDisclaimer />
      </BaseView>
    </BaseSafeFormView>
  )
}
